import React from 'react';
import { Create, SimpleForm, TextInput, SelectInput, required, email } from 'react-admin';

const roleChoices = [
	{ id: 'dev-front', name: 'Développeur Frontend' },
	{ id: 'dev-back', name: 'Développeur Backend' },
	{ id: 'po', name: 'Product Owner' },
	{ id: 'data_analyst', name: 'Data Analyst' },
	{ id: 'admin', name: 'Administrateur' },
];

export const McpMemberCreate = (props: any) => (
	<Create {...props}>
		<SimpleForm>
			<TextInput
				source="first_name"
				label="Prénom"
				validate={[required()]}
			/>
			<TextInput
				source="last_name"
				label="Nom"
				validate={[required()]}
			/>
			<TextInput
				source="email"
				label="Email"
				validate={[required(), email()]}
			/>
			<SelectInput
				source="role"
				label="Rôle"
				choices={roleChoices}
				validate={[required()]}
			/>
		</SimpleForm>
	</Create>
);
